import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function SearchAppBar() {
  const [username, setUsername] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    if (username.trim()) {
      navigate(`/?user=${encodeURIComponent(username.trim())}`); // Ensure proper URL encoding
    }
  };

  return (
    <nav className="searchBoxContainer">
      <div className="navContainer">
        <h2>Git Metrics</h2>
        <div className="searchInputContainer">
          <input
            type="text"
            placeholder="Enter Username"
            name="Unamebox"
            onChange={(e) => setUsername(e.target.value)}
          />
          <i className="fas fa-search" onClick={handleSearch}></i>
        </div>
      </div>
      <hr />
    </nav>
  );
}
